let hydrating = false;
let documentLocale: string | undefined;
const listeners = new Set<() => void>();

export function beginBrowserHydration(locale: string): void {
  hydrating = true;
  documentLocale = locale;
}

export function isBrowserHydrating(): boolean {
  return hydrating;
}

export function getBrowserHydrationLocale(): string | undefined {
  return hydrating ? documentLocale : undefined;
}

export function finishBrowserHydration(): void {
  if (!hydrating) return;
  hydrating = false;
  for (const listener of listeners) listener();
}

export function subscribeToBrowserHydration(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
